import React from "react";
import html2pdf from 'html2pdf.js';

import "./GetPDFButton.css";

function GetPDFButton({ numeroProcesso }) {

    const handleDonwload = async () => {
        let content;

        try {
            const response = await fetch(`https://apiatosoutorga.aesa.pb.gov.br/processo/${numeroProcesso.replace('/', '-')}`);
            const jsonResponse = await response.json();
            content = jsonResponse;

        } catch (err) {
            console.error(err.message);
        }

        const options = {
            margin: [10, 0, 10, 0],
            filename: 'arquivo.pdf',
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };

        html2pdf().set(options).from(content).output('dataurlnewwindow');
    };

    return (
        <button className="get-pdf-button-container" onClick={handleDonwload}>
            <span className="material-symbols-outlined">
                picture_as_pdf
            </span>
        </button>
    );
}

export default GetPDFButton;
